/* tslint:disable */
var TQuickStake =
{
    buttonsContainerId: "quick-stake-container",

    buttonClassName: "quick-stake-button",

    buildView(comboNumber, series) {
        if (!series || series.length == 0) {
            return "";
        }
        var __html = "";
        __html += `
            <div id="${this.buttonsContainerId}" class="quick-stake-container clearfix">`;
                for (var quickStakeIndex = 0; quickStakeIndex < series.length; quickStakeIndex++) { __html += `
                    <div class="quick-stake-container-item">
                        <button class="${this.buttonClassName}" type="button" data-comboNumber="${comboNumber}" value="+${series[quickStakeIndex]}">+${series[quickStakeIndex]}</button>
                    </div>`;
                } __html += `
            </div>`;
        return __html;
    }
};

window.TQuickStake = TQuickStake;